/**
 * 基础label样式
 * 填充 | 边框
 */
import * as React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
export default class BasicLabel extends React.PureComponent {
    render() {
        const { text, wrapperStyle, textStyle, textArray, splitStyle, leftIcon, accessibilityPreName } = this.props;
        if (Array.isArray(textArray)) {
            return (<View style={wrapperStyle}>
                    {textArray.map((str, index) => {
                if (index === 0) {
                    return (<Text key={`${str}${index}`} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#${index}`)} numberOfLines={1} style={textStyle}>
                                    {str}
                                </Text>);
                }
                else {
                    return [
                        <View key={`${str}${index}`} style={splitStyle}/>,
                        <Text key={`${str}${index}`} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel#${index}`)} numberOfLines={1} style={textStyle}>
                                    {str}
                                </Text>
                    ];
                }
            })}
                </View>);
        }
        return (<View style={[wrapperStyle, styles.flexRow]} {...qAccessibilityLabel(`${accessibilityPreName}qdLabel`)}>
                {React.isValidElement(leftIcon) ? (<View style={styles.iconCon}>{leftIcon}</View>) : null}
                {React.isValidElement(text) ? text : null}
                {typeof text === 'string' ? (<Text numberOfLines={1} style={textStyle}>
                        {text}
                    </Text>) : null}
            </View>);
    }
}
const styles = StyleSheet.create({
    flexRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    iconCon: {
        marginRight: 2
    }
});
